import React, {useContext, useEffect, useState} from "react";
import {Alert, Spin, Tabs} from "antd";
import useRMateChart from "./useRMateChart";
import Axios from "axios";
import ChartPane from "./ChartPane";
import MapPropsContext from "../MapPropsContext";
import {getApiHost, getLastYear} from "../../../utils";
import WidgetHelpChart from "../widgets/WidgetHelpChart";
import {
  layoutForChart1,
  layoutForChart2,
  layoutForChart3,
  layoutForChart4,
  layoutForChart5,
  processResponse
} from "./RMateChartResourceUserStatsUtils";


const RMateChartResourceUserStats = () => {

  const {chartAjaxParams} = useContext(MapPropsContext);

  const [response, setResponse] = useState({});
  const [isInit, setIsInit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const {sidoCode, searchYear} = chartAjaxParams;

  useEffect(() =>{
    window.chartBaseData = {
      chart1: {
        Data: [],
        DataSub1: [],
        DataSub2: [],
        Data10: [],
        DataSub11: [],
        DataSub21: [],
      },
      chart2: {
        Data: [],
        DataSub1: [],
        DataSub2: [],
        Data10: [],
        DataSub11: [],
        DataSub21: [],
      },
      chart3: {
        Data: [],
        DataSub1: [],
        DataSub2: [],
        Data10: [],
        DataSub11: [],
        DataSub21: [],
      },
      chart4: {
        Data: [],
        DataSub1: [],
        DataSub2: [],
        Data10: [],
        DataSub11: [],
        DataSub21: [],
      },
      chart5: {
        Data: [],
        DataSub1: [],
        DataSub2: [],
        Data10: [],
        DataSub11: [],
        DataSub21: [],
        xtitle: '지역',
        ytitle: '지수',
      },
    };
  }, []);

  useEffect(() => {
    if (isInit) {
      const url = getApiHost() + '/rwdinfolabstats/getAreaDvlpIdex.json';
      // const config = {params};
      const params = {
        sidoCode,
        searchYear,
      };

      setIsLoading(true);
      setError(null);

      if(sidoCode.length === 5)
      {
        const sidoitem = DISTRICT_LV1_OPTIONS.filter(item => item.value === sidoCode.substring(0, 2));
        let processedData = processResponse([], sidoCode.substring(0, 2), sidoitem.length > 0 ? sidoitem[0].label : "", sidoCode);
        setResponse(processedData);
        setIsLoading(false);
      }
      else
      {
        Axios.get(url,  sidoCode === undefined && searchYear === undefined ? {params:{sidoCode: "", searchYear: getLastYear()}}: {params})
            .then(({data}) => {
              const itemList = data.item;
              const sidoitem = DISTRICT_LV1_OPTIONS.filter(item => item.value === sidoCode);
              const processedData = processResponse(itemList, sidoCode, sidoitem.length > 0 ? sidoitem[0].label : "", "");
              setResponse(processedData);
              window.chartBaseData = processedData;
            })
            .catch(e => console.error(e))
            .finally(() => {
              setIsLoading(false);
            });
      }
    }
  }, [sidoCode, searchYear, isInit]);

  const {chart1, chart2, chart3, chart4, chart5} = response;

  return useRMateChart({
    init: () => {
      setIsInit(true)
    },
    style: {minHeight: '540px'},
    children: (
      <div>
        {isLoading &&
          <div style={{position: 'absolute', top: 55, zIndex: 1, height: '90%', width: '100%', backgroundColor: 'white'}}>
            <Spin size={"large"}>
              <Alert
                message="차트 로딩 중"
                description="선택한 무선국의 정보를 불러오는 중입니다.."
                type="info"
                showIcon
                style={{height: '510px'}}
              />
            </Spin>
          </div>
        }
        {isInit &&
        <Tabs defaultActiveKey={"1"} type={"card"}>
          <Tabs.TabPane tab={"전파·도시화 지수"} key={"1"}>
            {error && <Alert type={"error"} message={"오류가 발생했습니다."} />}
            <ChartPane data={chart1}
                       style={{height:'600px'}}
                       processor={chart1 && (() => chart1.Data)}
                       layoutProcessor={() => layoutForChart1(chart1)}/>
            <WidgetHelpChart/>
          </Tabs.TabPane>
          <Tabs.TabPane tab={"지역별 도시화/전파 지수"} key={"2"}>
            <ChartPane data={chart5}
                       processor={chart5 && (() => chart5.Data)}
                       style={{height:'600px'}}
                       layoutProcessor={() => layoutForChart5(chart5)}/>
          </Tabs.TabPane>

          <Tabs.TabPane tab={"인구 밀도/정보통신 자격현황"} key={"3"}>
            <ChartPane data={chart2}
                       processor={chart2 && (() => chart2.Data)}
                       style={{height:'600px'}}
                       layoutProcessor={() => layoutForChart2(chart2)}/>
          </Tabs.TabPane>

          <Tabs.TabPane tab={"시가화 지수/무선국 밀도"} key={"4"}>
            <ChartPane data={chart3}
                       processor={chart3 && (() => chart3.Data)}
                       style={{height:'600px'}}
                       layoutProcessor={() => layoutForChart3(chart3)}/>
          </Tabs.TabPane>

          <Tabs.TabPane tab={"전파Tech지수/재정자주도"} key={"5"}>
            <ChartPane data={chart4}
                       processor={chart4 && (() => chart4.Data)}
                       style={{height:'600px'}}
                       layoutProcessor={() => layoutForChart4(chart4)}/>
          </Tabs.TabPane>
        </Tabs>
        }
      </div>
    ),
  });
};



export default RMateChartResourceUserStats;

export let DISTRICT_LV1_OPTIONS = [
  {
    value: "11", label: "서울특별시", shortName: "서울"
  },
  {
    value: "26", label: "부산광역시", shortName: "부산",
  },
  {
    value: "27", label: "대구광역시", shortName: "대구",
  },
  {
    value: "28", label: "인천광역시", shortName: "인천",
  },
  {
    value: "29", label: "광주광역시", shortName: "광주",
  },
  {
    value: "30", label: "대전광역시", shortName: "대전",
  },
  {
    value: "31", label: "울산광역시", shortName: "울산",
  },
  {
    value: "36", label: "세종특별자치도", shortName: "세종",
  },
  {
    value: "41", label: "경기도", shortName: "경기",
  },
  {
    value: "42", label: "강원도", shortName: "강원",
  },
  {
    value: "43", label: "충청북도", shortName: "충북",
  },
  {
    value: "44", label: "충청남도", shortName: "충남",
  },
  {
    value: "45", label: "전라북도", shortName: "전북",
  },
  {
    value: "46", label: "전라남도", shortName: "전남",
  },
  {
    value: "47", label: "경상북도", shortName: "경북",
  },
  {
    value: "48", label: "경상남도", shortName: "경남",
  },
  {
    value: "50", label: "제주특별자치도", shortName: "제주",
  },
];